import { logger } from '@disy/lib/logging';

import type { CheckboxGroupEntry } from 'ui/checkbox-group/checkbox-group';

import { getStore } from 'cadenza/store/cadenza-store';
import type { ConditionGroupDto } from 'cadenza/workbook/model/condition-group-dto';
import type { ConditionGroupId } from 'cadenza/workbook/model/condition-group-id.gen';
import type { ConditionId } from 'cadenza/workbook/model/condition-id.gen';
import {
  conditionsAndGroupsModel,
  getConditionById,
  getConditionGroupById,
} from 'cadenza/workbook/workbook-core-selectors.state';

export function createOrEditConditionGroup(conditionGroupId?: ConditionGroupId) {
  return showConditionGroupDialog(
    getConditionChoices(conditionGroupId),
    conditionGroupId ? getConditionGroupById(getStore().getState(), conditionGroupId) : undefined,
  );
}

function getConditionChoices(conditionGroupId?: ConditionGroupId) {
  return conditionsAndGroupsModel(getStore().getState()).flatMap((conditionOrGroup) => {
    if (conditionOrGroup.id === conditionGroupId) {
      return (conditionOrGroup as ConditionGroupDto).conditions
        .map((conditionId) => getConditionById(getStore().getState(), conditionId))
        .map(({ id, printName }) => ({ value: id, label: printName, checked: true }));
    }

    // The conditions in conditionsAndGroups are by design ungrouped
    // and are used in the dialog as condition choices.
    const condition = getConditionById(getStore().getState(), conditionOrGroup.id as ConditionId);
    return condition ? [{ value: condition.id, label: condition.printName }] : [];
  });
}

function showConditionGroupDialog(conditionChoices: CheckboxGroupEntry[], conditionGroup?: ConditionGroupDto) {
  return import('cadenza/workbook/condition-group/condition-group-dialog')
    .then(({ ConditionGroupDialog }) => new ConditionGroupDialog(conditionChoices, conditionGroup).connectAndShow())
    .catch((error) => logger.error('Failed to show condition-group-dialog.', error));
}
